import React from 'react';
import {UserInfo} from './sub-view/user-info';
import {UserLayout} from 'components/layouts/user';

class ProfileContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <UserLayout active="profile">
        <h1 className="user-header">Thông tin cá nhân</h1>
        <UserInfo/>
      </UserLayout>
    );
  }
}

export default ProfileContainer;



// WEBPACK FOOTER //
// ./components/users/ProfileContainer.jsx